import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomIconActionRendererComponent } from './custom-icon-action-renderer.component';
import { MatButtonModule } from '@angular/material/button';
import { CustomPaginationComponent } from './custom-pagination/custom-pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { CustomMrnComponent } from './custom-mrn/custom-mrn.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CustomDatepickerComponent } from './custom-datepicker/custom-datepicker.component';
import { CustomValidationComponent } from './custom-validation/custom-validation.component';
import { CustomPopupComponent } from './custom-popup/custom-popup.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { CustomTooltipRenderer } from './custom-tooltip-renderer.component';
import { CustomFilterComponent } from './custom-filter-component';
import { CustomFloatingFilterComponent } from './custom-floating-filter-component';
import { CustomDobComponent } from './custom-dob/custom-dob.component';

@NgModule({
  declarations: [
    CustomIconActionRendererComponent,
    CustomPaginationComponent,
    CustomHeaderComponent,
    CustomDropdownComponent,
    CustomMrnComponent,
    CustomDatepickerComponent,
    CustomValidationComponent,
    CustomPopupComponent,
    CustomSelectComponent,
    CustomTooltipRenderer,
    CustomFilterComponent,
    CustomFloatingFilterComponent,
    CustomDobComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
  ],
  providers: [
    MatDatepickerModule
  ],
  exports: [
    CustomIconActionRendererComponent
  ]
})
export class GridRenderersModule { }
